import { useRef } from "react";

import { styled } from "simplydo/react/styled";

import { useAppSelector } from "store";

import { Sortable } from "components/lib/dnd/Sortable";

import { ILaneData } from ".";
import CustomLaneHeader from "../CustomLaneHeader";
import { LaneMeasuredVirtualList } from "./LaneMeasuredVirtualList";

export const LaneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 300px;
  width: 300px;
  scrollbar-width: thin;
  scrollbar-color: rgb(212, 213, 215) transparent;

  margin: 0 10px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  max-height: 100%;
  padding: 3px;

  .lane-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 8px;

    overflow: hidden;
  }

  border-radius: 5px;
  background: rgb(241, 242, 244);
  box-shadow:
    rgba(9, 30, 66, 0.25) 0px 1px 1px 0px,
    rgba(9, 30, 66, 0.31) 0px 0px 1px 0px;
`;

type ProjectLaneProps = { lane: ILaneData; index: number; loading: boolean };

export const ProjectLane = ({ lane, index, loading }: ProjectLaneProps) => {
  const dragRef = useRef<HTMLDivElement>(null);

  return (
    <Sortable
      key={lane.id}
      id={lane.id}
      index={index}
      type="lane"
      accept={["card", "lane"]}
      disabled={lane.draggingDisabled}
      style={{ height: "100%" }}
      handleRef={dragRef}
      collisionPriority="Low"
    >
      <LaneWrapper data-board-lane="">
        <CustomLaneHeader dragRef={dragRef} lane={lane} />

        <div className="lane-content">
          {lane.cards.length === 0 ?
            <div style={{ height: 100 }} />
          : <LaneMeasuredVirtualList lane={lane} loading={loading} />}
        </div>
      </LaneWrapper>
    </Sortable>
  );
};
